import AllInteressentsTable from './components/AllInteressentsTable';

export default AllInteressentsTable;
